module.exports = __webpack_public_path__ + "static/Austrian-map-13dc44e84e2c392e6ec6d14826ab31aa.png";